export const arrayByObjectKey = <T>(object: object, keyRegex: string): T[] =>
  Object.keys(object).reduce((acc, key) => {
    if (key.toLowerCase().includes(keyRegex.toLowerCase())) {
      return [...acc, object[key]];
    }
    return acc;
  }, []);
